export enum FeatureFlags {
  /**
   * string array containing the facility numbers that should have the ability to setup their delivery polygons.
   * This does not mean that the feature is enabled for delivery, just that they can draw their polygons
   */
  PolygonDeliveryConfigEnabled = 'polygon-delivery-config-enabled',
  PlannedHandoffExceptionsEnabled = 'planned-handoff-exceptions-enabled',
  PlannedDeliveryExceptions = 'planned-delivery-exceptions',
}
